import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { largeDate } from '../../utils/constants';
import { NavLink } from 'react-router-dom';
import { LogOut, HelpCircle, X } from 'react-feather';
import { logout } from '../../services/authService';

async function LogOutAction() {
  await logout();
  window.location = '/login';
}

const ProfilePane = (props) => {
  const { user, show, handleClose } = props;
  const { first_name, last_name } = user;
  const name = first_name + ' ' + last_name;
  const shortname =
    name.length > 0 ? first_name[0] + last_name[0] : first_name[0];
  const info = {
    email: 'Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    created_date: 'Created On',
    last_modified: 'Last Modified',
    expires_on: 'Password expiry'
  };

  const formatter = (column) => {
    if (
      column === 'created_date' ||
      column === 'last_modified' ||
      column === 'expires_on'
    ) {
      let last_upd = new Date(user[column] + 'Z');
      return last_upd.toLocaleString(undefined, largeDate);
    } else if (column.includes('is_')) {
      return user[column] ? 'Yes' : 'No';
    } else {
      return user[column];
    }
  };

  const Header = (
    <Row className='m-0 align-items-center name'>
      <div className='shortname'>{shortname}</div>
      <Col>
        <h6 className='m-0'>{name}</h6>
      </Col>
      <X onClick={handleClose} style={{ cursor: 'pointer' }} />
    </Row>
  );
  const PersonalInfo = (
    <Row className='m-0 pt-4 pb-4 align-items-center userinfo'>
      <Row className='m-0 mb-3 w-100 title'>
        <Col className='pl-0'>Profile information</Col>
        <NavLink to='/me' style={{ textDecoration: 'none', fontWeight: 600 }}>
          Edit
        </NavLink>
      </Row>
      {Object.keys(info).map((x, i) => {
        let value = formatter(x);
        return (
          <p className='w-100 mb-1' key={i}>
            {info[x]}:
            <span
              className='bold'
              style={{ overflowWrap: 'anywhere', fontFamily: 'Graphik Medium' }}
            >
              {'  '}
              {value}
            </span>
          </p>
        );
      })}
    </Row>
  );
  const Footer = (
    <>
      <Row
        className='m-0 mt-3 align-items-center signout'
        onClick={() => LogOutAction()}
      >
        <span to='' style={{ textDecoration: 'none' }}>
          <LogOut size={20} className='mr-2' />
          Sign Out
        </span>
      </Row>
      <Row className='m-0 align-items-center signout'>
        <NavLink to='/faqs' style={{ textDecoration: 'none' }}>
          <HelpCircle size={20} className='mr-2' />
          Check Frequently Asked Questions
        </NavLink>
      </Row>
    </>
  );
  return (
    <>
      <Row className={`profile m-0 ${show ? 'active' : ''}`}>
        <Col className='placeholder' onClick={handleClose}></Col>
        <Col id='profilepane' className={show ? 'active' : ''}>
          {Header}
          {PersonalInfo}
          {Footer}
        </Col>
      </Row>
    </>
  );
};

export default ProfilePane;
